import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';

const ModuleMenu = lazyPage(() => import('@/pages/ModuleMenu'));
const FeesDashboard = lazyPage(() => import('@/pages/fees/Dashboard'));
const FeeSetupWorkspace = lazyPage(() => import('@/pages/fees/FeeSetupWorkspace'));
const StudentBillingWorkspace = lazyPage(() => import('@/pages/fees/StudentBillingWorkspace'));
const LegacyBillingRedirect = lazyPage(() => import('@/pages/fees/LegacyBillingRedirect'));
const ConcessionsWorkspace = lazyPage(() => import('@/pages/fees/ConcessionsWorkspace'));
const LegacyCollectionsRedirect = lazyPage(() => import('@/pages/fees/LegacyCollectionsRedirect'));
const FinanceWorkspace = lazyPage(() => import('@/pages/fees/FinanceWorkspace'));
const FinanceSettingsWorkspace = lazyPage(() => import('@/pages/fees/FinanceSettingsWorkspace'));
const PaymentAccounts = lazyPage(() => import('@/pages/fees/PaymentAccounts'));
const ReportsWorkspace = lazyPage(() => import('@/pages/fees/reports/ReportsWorkspace'));

export const feesRoutes: AppRoute[] = [
  {
    path: 'fees',
    title: 'Fee Management',
    children: [
      { path: '', title: 'Fee Management', component: ModuleMenu },
      { path: 'dashboard', title: 'Dashboard', component: FeesDashboard, yearScoped: true },
      { path: 'setup', title: 'Fee Setup', component: FeeSetupWorkspace },
      { path: 'structures', title: 'Fee Setup', redirectTo: '/administrator/fees/setup?tab=structures' },
      { path: 'billing', title: 'Student Billing', component: StudentBillingWorkspace, yearScoped: true },
      { path: 'student-fees', title: 'Student Billing', component: LegacyBillingRedirect },
      { path: 'invoices', title: 'Student Billing', component: LegacyBillingRedirect },
        { path: 'collections', title: 'Student Billing', component: LegacyCollectionsRedirect, yearScoped: true },
        { path: 'collect', title: 'Student Billing', component: LegacyCollectionsRedirect },
        { path: 'receipts', title: 'Student Billing', component: LegacyCollectionsRedirect },
      { path: 'concessions', title: 'Concessions', component: ConcessionsWorkspace, yearScoped: true },
      { path: 'scholarships', title: 'Concessions', redirectTo: '/administrator/fees/concessions?tab=scholarships' },
      { path: 'refunds', title: 'Student Billing', component: LegacyCollectionsRedirect },
      { path: 'dues', title: 'Student Billing', component: LegacyBillingRedirect },
      { path: 'finance', title: 'Finance', component: FinanceWorkspace, yearScoped: true },
      { path: 'expenses', title: 'Finance', redirectTo: '/administrator/fees/finance?tab=expenses' },
      { path: 'budget', title: 'Finance', redirectTo: '/administrator/fees/finance?tab=budget' },
      { path: 'reports', title: 'Reports', component: ReportsWorkspace },
      { path: 'payment-accounts', title: 'Payment Accounts', component: PaymentAccounts },
      { path: 'settings', title: 'Settings', component: FinanceSettingsWorkspace },
      { path: 'heads', title: 'Fee Setup', redirectTo: '/administrator/fees/setup?tab=heads' },
      { path: 'head-types', title: 'Fee Setup', redirectTo: '/administrator/fees/setup?tab=head-types' },
      { path: 'terms', title: 'Fee Setup', redirectTo: '/administrator/fees/setup?tab=terms' },
    ],
  },
];
